













import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button } from '@/pages/profile/components';
import { IMentoringCardFooter } from './types';

@Component({
  components: {
    Button,
  },
})
export default class MentoringCardFooter extends Vue
  implements IMentoringCardFooter {
  @Prop({ type: String, default: '' })
  readonly text!: string;

  @Prop({ type: Boolean, default: true })
  readonly isButton!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/components/cardfooter/MentoringCardFooter.vue